import IndividualTable from "../../../IndividualTable";
import { sampleData2 } from "../../sampleData";

const Distance145 = () => {
  let winners = ["207"];
  return <IndividualTable matchType={"3"} gender="F" event="145" subTitle="Kungdo" data={sampleData2} topRankCount="1" winners={winners} />;
};
export default Distance145;
